<template>
  <page-article
    :page-title="currentJobDetailsGetter.job_title"
    :attachments="currentJobDetailsGetter.job_attachments"
  >
    <template slot="meta">
      <div class="col-5">
        <div class="row">
          <div class="col-4">
            <font-awesome-icon icon="calendar-alt" />
            {{ currentJobDetailsGetter.job_published_at || new Date() | moment("YYYY/MM/DD") }}
          </div>
        </div>
      </div>
    </template>
    <template>
      <div class="page_article_block col-12">
        <div class="article_info_item">
          <span class="article_tag">Company</span>
        </div>
        <div class="article_content">
          {{ currentJobDetailsGetter.job_enterprise_name }}
        </div>
        <div class="article_info_item">
          <span class="article_tag">Content</span>
        </div>
        <div
          class="article_content"
          v-html="currentJobDetailsGetter.job_content"
        />
      </div>
    </template>
  </page-article>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import pageArticle from '~components/pages/Article'
export default {
  name: 'JobOpeningEnDetailsContent',
  components: {
    pageArticle
  },
  computed: {
    ...mapGetters('pages/job-openings', [
      'currentJobDetailsGetter'
    ])
  },
  async created () {
	try {
		await this.getJobDetailsById(this.$route.params.id)
	} catch (err) {
		this.$router.push('/job-opening/en');
	}
  },
  methods: {
    ...mapActions('pages/job-openings', [
      'getJobDetailsById'
    ])
  }
}
</script>
